import React, { Component, ReactNode } from 'react';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import cx from 'classnames';

import { IAccount, IIdentifier } from '../../../slices/accounts/account';
import { selectors as accountListSelectors } from '../../../slices/accounts/list';
import { ViewTypes } from '../../../slices/adminDashboard/view';
import { selectors as authSelectors } from '../../../slices/auth';
import { RootState } from '../../../slices/rootReducer';
import { IUser } from '../../../slices/users/user';
import { Breadcrumb } from '../breadcrumb';
import { AccountsNavigationBar } from '../navigationBar/accountsNavigationBar';
import { AccessTypes } from '../domain/accountAccessType';

import styles from './dashboardHeader.module.scss';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';

const { Header } = Layout;

interface IDashboardHeaderProps {
  actions?: ReactNode[];
  loggedUser: IUser | null;
  pathname: string;
  accounts: IAccount[];
  accountId?: string;
  displayBillingTab: boolean;
}

class DashboardHeaderBase extends Component<IDashboardHeaderProps> {

  private renderActions() {
    const { actions = [] } = this.props;
    return (
      <div className={styles.actionsContainer}>
        {actions.map((action, index) => (
          <div className={styles.action} key={`${index}-header-action`}>
            {action}
          </div>
        ))}
      </div>
    );
  }

  render(): ReactNode {
    const { pathname, accountId = '', accounts, displayBillingTab = false } = this.props;
    const currentPath = pathname.replace('/', '');
    const isOnAccountsView = currentPath === ViewTypes.Account;
    const accountName = accountId && pathname.includes(accountId) ?
      accounts.find((account) => account.id === accountId)?.name ?? '' : '';
    const contentForHeader = (
      <Header className={styles.dashboardHeader}>
        <div className={cx(styles.subHeader, {
          [styles.showNavigator]: !isOnAccountsView,
          [styles[Features.PlgExternal3]]: isFeatureEnabled(Features.PlgExternal3)
        })}>
          {!isOnAccountsView && <AccountsNavigationBar displayBillingTab={displayBillingTab} />}
          {this.renderActions()}
        </div>
      </Header>
    );

    const routes = [
      {
        key: 'accounts',
        path: '/',
        breadcrumbName: 'Accounts'
      },
      {
        key: accountId,
        path: accountId,
        breadcrumbName: accountName
      }
    ];

    return (
      <div>
        <div className={styles.titleContainerDevelopment}>
          Admin
          {!isOnAccountsView && <Breadcrumb routes={routes} />}
        </div>
        {contentForHeader}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState, props: RouteComponentProps<IIdentifier>) => {
  let displayBillingTab = false;
  const { id = '' } = props.match.params;
  if (id) {
    const account = accountListSelectors.getAccountById(state, id);
    if (account !== null) {
      displayBillingTab = isFeatureEnabled(Features.PlgExternal3) || account.accessType === AccessTypes.Enterprise;
    }
  }
  return {
    pathname: props.location.pathname,
    accounts: accountListSelectors.getList(state),
    loggedUser: authSelectors.getLoggedInUser(state),
    displayBillingTab
  };
};

const ConnectedDashboardSettings = connect(mapStateToProps)(DashboardHeaderBase);

export const DashboardHeader = withRouter(ConnectedDashboardSettings);
